module.exports = __webpack_public_path__ + "img/Ssa4.0348d096.png";